import { environment } from "./environment.js";
import { features } from "./features.js";
import { htmlMeta } from "./html-meta.js";
const staging = {
    environment,
    htmlMeta,
    features
};
export { staging };
